export enum ApiTypes {
	KPO = "kpo",
	KPOK = "kpok",
}
